module.exports = __webpack_public_path__ + "static/media/abstract4.4e92eaa3.jpg";